import { connect } from 'react-redux'
import { goToAlbum } from '../../../../../actions'
import AlbumItem from './AlbumItem.jsx'

const mapDispatchToProps = (dispatch) => {
  return {
    goToAlbum: (id) => dispatch(goToAlbum(id))
  }
}

export default connect(undefined, mapDispatchToProps)(AlbumItem)



/** WEBPACK FOOTER **
 ** ./src/components/Media/Photos/Albums/AlbumItem/AlbumItem.js
 **/